<template>
    <NebulaPageWrapper class="page-wrapper" :contained="contained" padded ref="pageWrapper">
        <ErrorBanner v-if="pageError" :header="pageError.header || 'Something went wrong'" :description="pageError.description" color="red" />
        <BreadcrumbsRow v-if="breadcrumbs && hasBreadcrumbData" />
        <NebulaGridRow v-if="hasBanner" type="flex">
            <NebulaColumn :columns="12">
                <slot name="banner" />
            </NebulaColumn>
        </NebulaGridRow>
        <NebulaGridRow v-if="pageTitle" type="flex">
            <NebulaColumn :columns="12">
                <PageHeader :title="pageTitle">
                    <template v-slot:actions>
                        <slot name="actions" />
                    </template>
                </PageHeader>
            </NebulaColumn>
        </NebulaGridRow>
        <slot />
    </NebulaPageWrapper>
</template>

<script>
import { NebulaGrid } from '@discoveryedu/nebula-components';
import BreadcrumbsRow from '@/components/shared/layout/BreadcrumbsRow.vue';
import PageHeader from '@/components/shared/PageHeader.vue';
import ErrorBanner from '@/components/shared/ErrorBanner.vue';

import scrollToTop from '@/mixins/scrollToTop';
import { useMainStore } from '@/stores/useMainStore';
import { useAppStore } from '@/stores/useAppStore';

export default {
    setup() {
        const store = useMainStore();
        const appStore = useAppStore();
        return { store, appStore };
    },
    name: 'PageWrapperNew',
    components: {
        NebulaPageWrapper: NebulaGrid.NebulaPageWrapper,
        NebulaGridRow: NebulaGrid.NebulaGridRow,
        NebulaColumn: NebulaGrid.NebulaColumn,
        BreadcrumbsRow,
        PageHeader,
        ErrorBanner,
    },
    mixins: [scrollToTop],
    props: {
        pageTitle: String,
        contained: {
            type: Boolean,
            default: true,
        },
        breadcrumbs: Boolean,
    },
    computed: {
        pageError() {
            return this.store.page.error;
        },
        hasBanner() {
            return !!this.$slots.banner;
        },
        hasBreadcrumbData() {
            // Show breadcrumbs if there's at least 1 breadcrumb stored
            return this.appStore?.breadcrumb && this.appStore.breadcrumb.length > 0;
        },
    },
    mounted() {
        this.scrollToTop();
    },
    // beforeDestroy() {
    //     this.store.dispatch('resetPageData');
    // },
};
</script>

<style lang="stylus">
.page-wrapper {
    flex: 1;
    padding: $nebula-space-5x 0 $nebula-space-9x;
}
</style>
